import { useRef, useState } from "react";
import StickerLabel from "@/components/stickers/StickerLabel";
import { SAMPLE } from "@/lib/stickerDesign";

const PX = 96;

export default function LabelCanvas({ design, setElements, biz, logo, selected, setSelected }) {
  const { sheet, elements } = design;
  const scale = Math.min(3, 640 / (sheet.label_w * PX));
  const drag = useRef(null);
  const [, force] = useState(0);

  const down = (e, k) => {
    e.preventDefault();
    setSelected(k);
    drag.current = { k, sx: e.clientX, sy: e.clientY, x: elements[k].x, y: elements[k].y };
    e.currentTarget.setPointerCapture?.(e.pointerId);
  };
  const move = (e) => {
    const d = drag.current;
    if (!d) return;
    const x = +(d.x + (e.clientX - d.sx) / (PX * scale)).toFixed(3);
    const y = +(d.y + (e.clientY - d.sy) / (PX * scale)).toFixed(3);
    setElements(elements.map((el, i) => (i === d.k ? { ...el, x, y } : el)));
    force((n) => n + 1);
  };
  const up = () => { drag.current = null; };

  return (
    <div className="rounded-lg border bg-neutral-100 p-6 overflow-auto" onPointerMove={move} onPointerUp={up} onPointerLeave={up} data-testid="label-canvas">
      <div style={{ width: sheet.label_w * PX * scale, height: sheet.label_h * PX * scale }}>
        <div style={{ transform: `scale(${scale})`, transformOrigin: "top left", background: "#fff", boxShadow: "0 1px 6px rgba(0,0,0,.25)", width: "fit-content" }}>
          <StickerLabel sheet={sheet} elements={elements} decor={design.decor} data={SAMPLE} biz={biz} logo={logo} selected={selected} onPointerDown={down} />
        </div>
      </div>
      <p className="mt-3 text-xs text-neutral-500">Drag the lines to place them. Click a line to change its size or style.</p>
    </div>
  );
}
